/* eslint-disable import/prefer-default-export */
/* eslint-disable quotes */
import styled from "styled-components";

export const HomeContainer = styled.div`
  padding: 40px 20px;
`;
